module.exports = __webpack_public_path__ + "static/media/动力系统附件.9c4d1d43.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/dongfeng/faultDiagnosis/demo/image/动力系统附件.png
// module id = 1713
// module chunks = 174